import React from "react";

import "./LanguageSelection.scss";
import { Language } from "../core";

interface LanguageSelectionProps {
  language: Language;
  onChangeLanguage: (language: Language) => void;
}
export const LanguageSelection: React.FC<LanguageSelectionProps> = ({
  language,
  onChangeLanguage
}) => {
  return (
    <div
      className="languageSelection"
      onChange={evt =>
        onChangeLanguage((evt.target as HTMLInputElement).value as Language)
      }
    >
      <input
        id="language-english"
        type="radio"
        name="language"
        value="english"
        defaultChecked={language === "english"}
      />
      <label htmlFor="language-english">English</label>
      <input
        id="language-finnish"
        type="radio"
        name="language"
        value="suomi"
        defaultChecked={language === "suomi"}
      />
      <label htmlFor="language-finnish">Suomi</label>
    </div>
  );
};
